<template>
    <span >
        <v-chip small @click="$refs.inputUpload.click()" class="indigo white--text">
        <v-icon class="amber--text" small >fas fa-upload</v-icon> &nbsp; 
        <span >Attach File</span>
        </v-chip> 
        {{type}}
        <input v-show="false" ref="inputUpload" type="file" @change="fileUpload" >
    </span>
</template>
<script>
//import DocumentModel from '@/modules/teams/service/DocumentService';
import DocumentModel from '@/api/service/DocumentService';
export default {
    props:[
      'dataType',
      'data',
      'type',
      'key_id'
    ],
    data () {
      return {
       file:{
           "imageName":"",
           "imageUrl":"",
           "imageFile":""
       },
       moduleType:this.dataType
      }
    },
    watch:{
        dataType(){
            this.moduleType = this.dataType
        },
        key_id(){
            this.key_id=this.key_id
        }
    },
    mounted:function() {
        this.moduleType = this.dataType
    },  
    methods: {
        setData($data) {
             this.$emit('uploadCompleted',$data)
            //this.data = $data 
        },
        fileUpload($event) {
            var $data ;
            const files = $event.target.files
            
            if(files[0] !== undefined) {
				this.file.imageName = files[0].name
				if(this.file.imageName.lastIndexOf('.') <= 0) {
					return
				}
                const fr = new FileReader ()
                var $dataType = this.dataType
                var $file = this.file
                var $type = this.type
                var $keyId = this.key_id
                if(!$keyId) { $keyId = 100}
                if(this.type!='UP') {
                    $type=$dataType
                } else {
                    $type='UP'+$dataType
                }
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					$file.imageUrl = fr.result
                    $file.imageFile = files[0] // this is an image file that can be sent to server...
                    var $json= {
                            "key_type":$type,
                            "key_id":$keyId,
                            "doc_type_id":1,
                            "name":$file.imageName,
                            "doc_name":$file.imageName,
                            "file_name":$file.imageName,
                            "file_type":$file.imageFile.type ,
                            "active":1,
                            "data":$file.imageUrl,
                            "company_id":JSON.parse(localStorage.getItem('tiburaClinic')).data.User.company_id
                            
                        }
                    if($dataType==='##') {
                        this.setData($file.imageUrl)
                        
                    } else {
                    DocumentModel.upload($json)
                        .then(response => {
                            this.setData(response.data.data)
                              //resolve("File Uploaded")
                        }).catch(error => {
                            console.log(error)
                            //reject(error)
                        }); 
                    }
			    })
			} else {
				this.file.imageName = ''
				this.file.imageFile = ''
				this.file.imageUrl = ''
            }
        }
    }
  }
</script>